import * as React from "react";
const SvgFilter24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 23,
        fill: "black",
        viewBox: "0 0 23 23"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h23l-8.5 11.333v8.714l-6 2.7V11.333L0 0Zm4 2 6.5 8.667v8.986l2-.9v-8.086L19 2H4Z",
      clipRule: "evenodd"
    })
  );
export default SvgFilter24Px;
